import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie';
import Navbar from '../components/navbar';
import { AiFillDelete, AiOutlineMail, AiTwotoneInteraction } from "react-icons/ai"
import '../css/shipping.css'
import { AutoComplete, message, Modal } from 'antd';
import axios from 'axios';

function Forms(params) {

    const type = params.kittype




    const [btn, setbtn] = useState(true)
    const [name, setname] = useState("")
    const [email, setemail] = useState("")
    const [KitCode, setKitCode] = useState("")
    const [DOB, setDOB] = useState("")
    const [sampledate, setsampledate] = useState("")

    const [form, setForm] = useState({
        country: '',
        weight_unit: '',
        weight: '',
        height_unit: '',
        height: '',
        gender: '',
        antibiotics: '',
        healthConditions: [],
        dietType: [],
        eatingHabits: []
    });

    const [firstform, setfirstform] = useState(true)

    const backgroundcolor = Cookies.get("backgroundcolor") || params.backgroundcolor;
    const color = Cookies.get("color") || params.color;
    const Buttonbackgroundcolor = Cookies.get("Buttonbackgroundcolor") || params.Buttonbackgroundcolor;
    const Buttoninsidecolor = Cookies.get("Buttoninsidecolor") || params.Buttoninsidecolor;
    const prinarycolor = Cookies.get("prinarycolor") || params.prinarycolor;
    const prinarycolortext = Cookies.get("prinarycolortext") || params.prinarycolortext;
    const seconderycolor = Cookies.get("seconderycolor") || params.seconderycolor;
    const portalid = Cookies.get("portalid") || params.portalid;
    const [countries, setCountries] = useState([]);
    const [showThankYou, setShowThankYou] = useState(false);



    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await axios.get('https://restcountries.com/v3.1/all');
                // Sort countries alphabetically by name
                const sortedCountries = response.data.sort((a, b) =>
                    a.name.common.localeCompare(b.name.common)
                );
                setCountries(sortedCountries);
            } catch (error) {
                console.error('Error fetching countries:', error);
            }
        };

        fetchCountries();
    }, []);





    const uploaddata = async () => {





        await setbtn(false)
        setfirstform(true)
        let data = JSON.stringify({
            "name": name,
            "email": email,
            "sampledate": sampledate,
            "KitCode": KitCode,
            "DOB": DOB,
            "type": type,
            "formtype": 'normal',
            "secondform": form,
            portalid: portalid
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: process.env.REACT_APP_APIURL + '/submitformdata',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        await axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));

                if (response.status === 200) {
                    setbtn(true)
                    setname("")
                    message.success(response.data.Message)
                    setemail("")
                    setKitCode("")
                    setDOB("")
                    setsampledate("")
                    setForm(({
                        country: '',
                        weight_unit: '',
                        weight: '',
                        height_unit: '',
                        height: '',
                        gender: '',
                        antibiotics: '',
                        healthConditions: [],
                        dietType: [],
                        eatingHabits: []
                    }))
                    setShowThankYou(true);
                } else if (response.status === 202) {
                    setbtn(true)
                    message.error(response.data.Message)
                }


            })
            .catch((error) => {
                console.log(error);
            });









    }




    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleRadioChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const handleCheckboxChange = (field, value) => {
        setForm((prev) => {
            const current = new Set(prev[field]);
            current.has(value) ? current.delete(value) : current.add(value);
            return { ...prev, [field]: Array.from(current) };
        });
    };




    const [options, setOptions] = useState([{
        value: "United Kingdom"
    }, {
        value: "Ireland"
    }]);



    const handleSearch = (searchText) => {
        if (!searchText) {
            setOptions([]); // Clear options if no search text
            return;
        }

        // Filter countries that include the search text
        const filteredCountries = countries
            .filter(item => item.name.common.toLowerCase().includes(searchText.toLowerCase()))
            .map(item => ({
                value: item.name.common, // Use country name as value
                label: item.name.common  // Use country name as label
            }));

        setOptions(filteredCountries);
    };

    return (<>


        <Navbar />
        <div className='deshboardmain formssssss' style={{ justifyContent: 'center', alignItems: 'center', backgroundColor: backgroundcolor }}>
            <div className='formcss'>

                {btn ? (<>

                    <h1 style={{ color: prinarycolor }} >{type} Form</h1>

                    {firstform ?
                        (<>
                            <form className='kitform' onSubmit={(e) => {
                                e.preventDefault()

                                if (type !== "Microbiome") { uploaddata() } else {
                                    setfirstform(false)
                                }



                            }}>



                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }} >Name <span style={{ color: "red" }}>*</span></label>
                                    <input className='kitforminput' onChange={(e) => setname(e.target.value)} value={name} required placeholder='Name' />
                                </div>

                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }} >Email <span style={{ color: "red" }}>*</span></label>
                                    <input className='kitforminput' onChange={(e) => setemail(e.target.value)} value={email} required placeholder='Email' />
                                </div>




                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }} >Sample Date <span style={{ color: "red" }}>*</span></label>
                                    <input className='kitforminput' type='date' onChange={(e) => setsampledate(e.target.value)} value={sampledate} required placeholder='Email' />
                                </div>


                                {(type === "FoodSensitivityMap" && portalid === "67c17d743394a458c944eec2") ? (<>
                                    <div className='kitformdiv testttttt'>
                                        <label className='kitformlebel' style={{ color: prinarycolor }} >Kitcode Number  <span style={{ color: "red" }}>*</span></label>
                                        <input className='kitforminput' type='number' onInput={(e) => {
                                            e.target.value = e.target.value.slice(0, 14); // Restrict to 14 digits
                                        }} style={{ paddingLeft: '32px' }} onChange={(e) => setKitCode(e.target.value)} value={KitCode} required placeholder='Kit-Code' />
                                    </div>

                                </>) : (<>
                                    <div className='kitformdiv'>
                                        <label className='kitformlebel' style={{ color: prinarycolor }} >Kitcode Number  <span style={{ color: "red" }}>*</span></label>
                                        <input className='kitforminput' onChange={(e) => setKitCode(e.target.value)} value={KitCode} required placeholder='Kit-Code' />
                                    </div>
                                </>)}


                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }} >Date Of Birth  <span style={{ color: "red" }}>*</span></label>
                                    <input className='kitforminput' type='date' onChange={(e) => setDOB(e.target.value)} value={DOB} required placeholder='Phone' />
                                </div>












                                <button className='button' disabled={!btn} style={{ width: "100%", backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor, padding: "10px 0px" }}>Next</button>



                            </form>
                        </>) : (<>

                            <form className='kitform' onSubmit={uploaddata}>
                                {/* Country */}
                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }}>
                                        In which country do you live? <span style={{ color: 'red' }}>*</span>
                                    </label>


                                    <AutoComplete
                                        options={options}
                                        style={{ borderRadius:"5px" }}
                                        placeholder="Search for Conutry"
                                        required
                                        className='autocompleee'
                                        value={form.country}
                                        onSearch={handleSearch}  // When typing, call handleSearch
                                        onSelect={(e) => setForm((prev) => ({ ...prev, country: e }))}  // Handle selection
                                        onChange={(e) => setForm((prev) => ({ ...prev, country: e }))}
                                    />
                                </div>

                                {/* Weight */}
                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }}>How much do you weigh? <span style={{ color: 'red' }}>*</span></label>
                                    <div style={{ display: 'flex', gap: '50px',alignItems:"center"  }}>
                                        <label className='kitformlebel' style={{ color: prinarycolor }}><input type='radio' name='weight_unit' value='lbs' checked={form.weight_unit === 'lbs'} onChange={handleChange} /> Pounds</label>
                                        <label className='kitformlebel' style={{ color: prinarycolor }}><input type='radio' name='weight_unit' value='kg' checked={form.weight_unit === 'kg'} onChange={handleChange} /> Kilograms</label>
                                    </div>
                                    <input className='kitforminput' type='number' name='weight' value={form.weight} onChange={handleChange} required placeholder='Your weight' />
                                </div>

                                {/* Height */}
                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }}>How tall are you? <span style={{ color: 'red' }}>*</span></label>
                                    <div style={{ display: 'flex', gap: '50px',alignItems:"center"  }}>
                                        <label className='kitformlebel' style={{ color: prinarycolor }}><input type='radio' name='height_unit' value='feet' checked={form.height_unit === 'feet'} onChange={handleChange} /> Feet & Inches</label>
                                        <label className='kitformlebel' style={{ color: prinarycolor }}><input type='radio' name='height_unit' value='cm' checked={form.height_unit === 'cm'} onChange={handleChange} /> Centimeters</label>
                                    </div>
                                    <input className='kitforminput' type='text' name='height' value={form.height} onChange={handleChange} required placeholder='Your height' />
                                </div>

                                {/* Gender */}
                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }}>Your gender at birth? <span style={{ color: 'red' }}>*</span></label>
                                    <div style={{ display: 'flex', gap: '50px',alignItems:"center" }}>
                                        <label className='kitformlebel' style={{ color: prinarycolor }}><input type='radio' name='gender' value='male' checked={form.gender === 'male'} onChange={handleChange} /> Male</label>
                                        <label className='kitformlebel' style={{ color: prinarycolor }}><input type='radio' name='gender' value='female' checked={form.gender === 'female'} onChange={handleChange} /> Female</label>
                                    </div>
                                </div>

                                {/* Health Conditions */}
                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }}>Do you have any of the below health conditions or concerns? <span style={{ color: 'red' }}>*</span></label>


                                    <div >
                                        {[
                                            "Irritable Bowel Syndrome",
                                            "Inflammatory Bowel Disease",
                                            "Bloating / Gas issues",
                                            "I would like to lose weight",
                                            "I would like to gain weight",
                                            "Thyroid Conditions",
                                            "Heart / Cardiovascular problems",
                                            "Skin Conditions",
                                            "Headaches / Migraines",
                                            "Food Intolerances",
                                            "Arthritis",
                                            "Sleep Problems",
                                            "Diabetes",
                                        ].map((condition, i) => (
                                            <div key={i} style={{ display: 'flex', alignItems: "center" }}>
                                                <input

                                                    type='checkbox'
                                                    checked={form.healthConditions.includes(condition)}
                                                    onChange={() => handleCheckboxChange('healthConditions', condition)}
                                                />
                                                <label className='kitformlebel' style={{ color: prinarycolor }} >{condition}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Antibiotics */}
                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }}>Have you taken antibiotics in the last 12 months? <span style={{ color: 'red' }}>*</span></label>
                                    <div style={{ display: 'flex', gap: '50px' }}>
                                        <label className='kitformlebel' style={{ color: prinarycolor }}><input type='radio' name='antibiotics' value='yes' checked={form.antibiotics === 'yes'} onChange={handleChange} /> Yes</label>
                                        <label className='kitformlebel' style={{ color: prinarycolor }}><input type='radio' name='antibiotics' value='no' checked={form.antibiotics === 'no'} onChange={handleChange} /> No</label>
                                    </div>
                                </div>

                                {/* Diet Type */}
                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }} >What best describes your diet type? <span style={{ color: 'red' }}>*</span></label>
                                    <div >
                                        {["Omnivore", "Vegetarian", "Vegan", "Pescetarian"].map((type, i) => (
                                            <div key={i} style={{ display: 'flex', alignItems: "center" }}>
                                                <input

                                                    type='checkbox'
                                                    checked={form.dietType.includes(type)}
                                                    onChange={() => handleCheckboxChange('dietType', type)}
                                                />
                                                <label className='kitformlebel' style={{ color: prinarycolor }} >{type}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Eating Habits */}
                                <div className='kitformdiv'>
                                    <label className='kitformlebel' style={{ color: prinarycolor }}>Do you follow any of these eating habits? <span style={{ color: 'red' }}>*</span></label>
                                    <div >
                                        {[
                                            "Intermittent Fasting",
                                            "High Protein",
                                            "Low Protein",
                                            "Ketogenic",
                                            "High Carbohydrate",
                                            "Low Carbohydrate",
                                        ].map((habit, i) => (
                                            <div key={i} style={{ display: 'flex', alignItems: "center" }}>
                                                <input

                                                    type='checkbox'
                                                    checked={form.eatingHabits.includes(habit)}
                                                    onChange={() => handleCheckboxChange('eatingHabits', habit)}
                                                />
                                                <label className='kitformlebel' style={{ color: prinarycolor }}>{habit}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Navigation Buttons */}
                                <div>
                                    <button className='button' type='button' onClick={() => setfirstform(true)} style={{ width: '100%', backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }}>
                                        Previous
                                    </button>

                                    <button className='button' type='submit' style={{ width: '100%', marginTop: '10px', backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }}>
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </>)}



                </>) : (<>
                    <img alt='' src='/empty.gif' width={"35%"} />
                </>)}

            </div>
        </div >

        {showThankYou && (
            <Modal open={showThankYou} onCancel={() => setShowThankYou(false)} footer={null} centered>
                <div style={{ textAlign: 'center', padding: '30px 0' }}>
                    <h2>Thank you!</h2>
                    <p>Your form has been submitted successfully.</p>
                    <button className='button' style={{ marginTop: 20 }} onClick={() => setShowThankYou(false)}>Close</button>
                </div>
            </Modal>
        )}

    </>)
}

export default Forms
